import { render, staticRenderFns } from "./Liquidity.vue?vue&type=template&id=ba9ef416&scoped=true"
import script from "./Liquidity.vue?vue&type=script&lang=js"
export * from "./Liquidity.vue?vue&type=script&lang=js"
import style0 from "./Liquidity.vue?vue&type=style&index=0&id=ba9ef416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9ef416",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VLazy,VProgressLinear})
